var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.site && _vm.marketData)?_c('layout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }